module.exports = __webpack_public_path__ + "img/project2.2982c78c.png";